<template>
    <div class="basic_wrap popup">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
<!--            <div class="big_tit">{{$t('Member Center')}}</div>-->
        </div>
        <div class="wrap">
            <div class="top">
                <img src="@/assets/images/chip/top.png" />
            </div>
            <div class="main">
                <div class="row">
                    <div class="font-14 chip-color underline" @click="showRule = true">{{$t('Event Rules')}}</div>
                    <div class="font-14 chip-color underline" @click="openDrawRecord">{{$t('Award History')}}</div>
                </div>
                <div class="mt-20">
                    <div class="item">
                        <div><img src="@/assets/images/chip/chip01.png"></div>
                        <div>
                            <div class="font-14">{{$t('A')}}</div>
                            <div class="chip-color">{{$t('Team Total Recharge Reached')}} {{$t('currency')}}500</div>
                        </div>
                        <div class="right btn">{{$t('Today')}}：{{todayContribute}}</div>
                    </div>
                    <div class="item mt-10">
                        <div><img src="@/assets/images/chip/chip02.png"></div>
                        <div>
                            <div class="font-14">{{$t('B')}}</div>
                            <div class="chip-color">{{$t('Daily Task')}}</div>
                        </div>
                        <div class="right btn">{{$t('Today')}}：{{todayActive}}</div>
                    </div>
                    <div class="item mt-10">
                        <div><img src="@/assets/images/chip/chip03.png"></div>
                        <div>
                            <div class="font-14">{{$t('C')}}</div>
                            <div class="chip-color">{{$t('Invite One Member Complete Registration')}}</div>
                        </div>
                        <div class="right btn">{{$t('Today')}}：{{todayNewcomer}}</div>
                    </div>
                    <div class="item mt-10">
                        <div><img src="@/assets/images/chip/chip04.png"></div>
                        <div>
                            <div class="font-14">{{$t('D')}}</div>
                            <div class="chip-color">{{$t('Invite One member Lease Any Chip')}}</div>
                        </div>
                        <div class="right btn">{{$t('Today')}}：{{todayAssistance}}</div>
                    </div>
                </div>
                <div class="mt-20 white-bg">
                    <div class="text-center font-14 mb-10">{{$t('My Pieces')}}</div>
                    <div class="img-grid">
                        <div>
                            <van-badge :content="totalContribute" color="#f4b42e"><img src="@/assets/images/chip/chip01.png"></van-badge>
                        </div>
                        <div>
                            <van-badge :content="totalActive" color="#f4b42e"><img src="@/assets/images/chip/chip02.png"></van-badge>
                        </div>
                        <div>
                            <van-badge :content="totalNewcomer" color="#f4b42e"><img src="@/assets/images/chip/chip03.png"></van-badge>
                        </div>
                        <div>
                            <van-badge :content="totalAssistance" color="#f4b42e"><img src="@/assets/images/chip/chip04.png"></van-badge>
                        </div>
                    </div>
                </div>


                <div class="box">
                    <div v-for="(item,index) in list" :key="index" class="item">
                        <div @click="itemClick(item,index)">
                            <div :class="['card1', (item.status > 0 ? 'hide' : ''), (item.clicking ? 'card-click' : '')]">
                                <template>
                                    <img :src="require(`@/assets/images/chip/award.png`)"  class="prize-img" />
                                </template>
                            </div>

                            <div
                                    :class="{
                                  'card2 show': item.status === 1,
                                  'card2': item.status === 0,
                                  'card2 show-result': item.status === 2
                                }"
                            >
                                <template>
                                    <div class="pd-lr-5">
                                        <div class="prizeimg"><img :src="item.logo"/></div>
<!--                                        <div class="mt-5">{{ item.name }}</div>-->
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="common-btn">
                    <div class="font-16 font-bold">{{$t('Pieces Synthesis')}}</div>
                    <div class="btn-color mt-5">{{$t('Use 4 Different Pieces')}}</div>
                </div>
            </div>
            <div class="clean"></div>
        </div>

        <!-- 活动规则 -->
        <van-popup v-model="showRule" position="center" round :style="{ width: '80%', padding: '16px' }">
            <div class="action-sheet-center">
                <div style="max-height: 400px; overflow-y: auto;">
                    <div class="text-center font-16 font-bold mt-10 font-white">{{rule.title}}</div>
                    <div class="mt-20 font-14 font-white" v-html="rule.content"></div>
                </div>
                <div class="btn-white" @click="showRule = false">{{$t('OK')}}</div>
            </div>
        </van-popup>

        <!-- 抽奖记录 -->
        <van-popup v-model="showRecord" position="center" round :style="{ width: '80%', padding: '16px' }">
            <div class="action-sheet-center">
                <div class="content" style="max-height: 300px; overflow-y: auto;">
                    <div class="mt-10">
                        <van-cell v-for="item in drawRecordList" :key="item.id">
                            <!-- 自定义标题区域 -->
                            <template slot="title">
                                <div class="cell-title">{{ item.add_time }}</div>
                            </template>

                            <!-- 自定义右侧内容区域 -->
                            <div class="cell-value">{{ item.name }}</div>
                        </van-cell>
                    </div>
                    <div class="mt-30"></div>
                </div>
                <div class="btn-white" @click="showRecord = false">{{$t('OK')}}</div>
            </div>
        </van-popup>

    </div>
</template>

<script>
    import Fetch from "../../utils/fetch";

    export default {
        name: "index",
        data() {
            return {
                rule: {},
                todayContribute: 0,
                todayActive: 0,
                todayNewcomer: 0,
                todayAssistance: 0,
                totalContribute: 0,
                totalActive: 0,
                totalNewcomer: 0,
                totalAssistance: 0,
                showRule: false,
                showRecord: false,
                drawRecordList: [], // 中奖记录
                drawNum: 0,
                money: 0,
                list: [], // 奖品列表
            }
        },
        created() {
            this.$parent.footer('index', false);

            // 隐藏底部菜单
            this.$parent.footer('index', false);
            // 打乱顺序
            this.list.sort(() => Math.random() - 0.5);
            this.init();
        },
        mounted() {
            this.init();
        },
        methods: {
            // 初始化数据
            init() {
                // 获取用户收集碎片信息
                Fetch('/user/chipData').then(r => {
                    this.rule = r.data.rule;
                    this.todayContribute = r.data.today_contribute;
                    this.todayActive = r.data.today_active;
                    this.todayNewcomer = r.data.today_newcomer;
                    this.todayAssistance = r.data.today_assistance;
                    this.totalContribute = r.data.total_contribute;
                    this.totalActive = r.data.total_active;
                    this.totalNewcomer = r.data.total_newcomer;
                    this.totalAssistance = r.data.total_assistance;
                    this.drawNum = r.data.flip_num;
                })

                // 获取奖品列表
                Fetch('/shard_lucky_draw', { }).then((r) => {
                    this.list = r.data.prizelist.map((it) => ({
                        ...it,
                        status: 0, // 0:未翻牌 1:已中奖牌 2:其他翻开
                        clicking: false,
                    }));
                    this.drawNum = r.data.luckynum; // 可用抽奖次数
                    this.money   = r.data.money; // 可用余额
                });
            },
            // 点击翻牌
            async itemClick(item, index) {
                if (this.drawNum <= 0) {
                    this.$toast(this.$t("Failed, insufficient fragments"));
                    return;
                }

                // 给卡片加点击动画
                this.$set(item, 'clicking', true);

                await Fetch('/shard_lucky_draw/get_lucky_result?type=2', { }).then((r) => {
                    this.drawNum = r.data.luckynum; // 设置可用抽奖次数
                    this.drawId = r.data.drawId; // 设置获得的奖品ID
                    this.drawTitle = r.data.title; // 中奖标题
                    this.money = r.data.money; // 用户剩余金额
                    this.rewardNum = r.data.reward_num; // 抽中的奖品数量

                    const winIndex = this.list.findIndex(it => Number(it.id) === this.drawId);

                    // 动画结束后翻牌
                    setTimeout(() => {
                        // 把“中奖项”与“用户点击项”交换位置，这样点击的那张就是中奖的
                        if (winIndex !== -1 && winIndex !== index) {
                            const tmp = this.list[index];
                            this.$set(this.list, index, this.list[winIndex]);
                            this.$set(this.list, winIndex, tmp);
                        }

                        // 现在点击位就是中奖卡
                        const clicked = this.list[index];
                        clicked.status = 1;
                        clicked.flipped = true;
                        this.$set(item, 'clicking', false); // 移除点击动画类

                        // 翻开剩余的卡片
                        setTimeout(() => {
                            this.list.forEach(it => {
                                if (it.status !== 1) {
                                    it.status = 2;
                                }
                            });
                        }, 1500); // 延迟 1500 毫秒

                        // 如果还有抽奖次数，5 秒后复原
                        if (this.drawNum > 0) {
                            setTimeout(() => {
                                this.list.forEach(it => {
                                    it.status = 0;     // 恢复未翻开状态
                                    it.flipped = false;
                                });
                                // 洗牌，让下一轮随机
                                this.list.sort(() => Math.random() - 0.5);

                                // 重新初始化数据
                                this.init();
                            }, 5000); // 延迟 5 秒
                        }

                    }, 300); // 动画持续时间
                });
            },
            openDrawRecord() {
                this.showRecord = true;
                this.drawRecord();
            },
            // 获取抽奖记录
            async drawRecord() {
                await Fetch('/shard_lucky_draw/get_draw_record', { }).then((r) => {
                    this.drawRecordList = r.data;
                });
            },
        },
    }
</script>

<style lang="less" scoped>
    .red_top_bg {
        position: absolute;
        background: unset;
    }
    .back_left {
        padding-left: 30px;
        background: url(../../views/images/item/back.png) no-repeat center center;
    }
    .big_tit{
        color: #000000;
    }
    .basic_wrap {
        background: #99c999;
        min-height: 100vh;
    }
    .wrap { }
    .top {
    }
    .top img{
        width: 100%;
    }
    .main {
        background: #f4fff4;
        margin: 10px;
        padding: 30px 12px;
        border-radius: 10px;
    }
    .chip-color {
        color: #0b9444;
    }
    .item {
        display: flex;
        align-items: center;          /* 垂直居中，可选 */
        justify-content: space-between; /* 左右分布 */
    }

    .item > div:nth-child(1),
    .item > div:nth-child(2) {
        display: flex;
        flex-direction: column; /* 第二个 div 内文字上下排列 */
    }

    .item .right {
        margin-left: auto;  /* 强制靠右 */
    }
    .item {
        background: #fff;
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        padding: 10px;
        border-radius: 8px;
    }
    .item > div:nth-child(1) img {
        height: 60px;
    }
    .item > div:nth-child(2) {
        margin-left: 10px;
        margin-right: 10px;
    }
    .item > div:nth-child(2) div {
        line-height: 20px;
    }
    .item .btn {
        background: #0b9444;
        color: #fff;
        padding: 6px 8px;
        border-radius: 5px;
        min-width: 68px;
    }
    .img-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr); /* 一行4列 */
        gap: 10px;                             /* 图片之间的间距 */
        align-items: center;
        justify-items: center;                 /* 每个格子里的内容居中 */
        margin-top: 20px;
    }

    .img-grid img {
        max-width: 60px;   /* 限制最大宽度 */
        height: auto;      /* 保持比例 */
        display: block;
    }

    // 翻牌效果
    .box {
        display: grid;
        grid-template-columns: repeat(3, 1fr); /* 一行 2 列 */
        gap: 15px; /* 卡片间距 */
        justify-items: center;
        width: 270px;
        margin: 0 auto;
        margin-top: 20px;

        .item {
            position: relative;
            width: 80px;
            height: 80px;
            background:unset;
            box-shadow:unset;
        }

        .card1,
        .card2 {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 8px;
            text-align: center;
            transition: transform 0.4s;
        }

        .card1 {
            color: #fff;
            padding: 2px;
        }
        .card1 .prize-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .card2 {
            color: #fff;
            padding: 0 10px;
            transform: scaleX(0);
        }

        .hide {
            transform: scaleX(0);
        }
        .show {
            transform: scaleX(1);
            font-weight: 700;
            color: #FFD700;
        }
        .show-result {
            transform: scaleX(1);
            opacity: 0.3;
        }
        /* 点击时的缩放弹跳效果 */
        .card-click {
            animation: clickScale 0.3s forwards;
        }
        @keyframes clickScale {
            0% { transform: scale(1); }
            50% { transform: scale(1.1); }
            100% { transform: scale(1); }
        }
        .illustrate {
            background: #000;
            margin: 10px 15px 0 15px;
            padding: 0 10px;
            font-size: 14px;
            text-align:center;
            color: #fff;
            border: 0.3rem solid #333;
            border-top: 0.48rem solid #333;
            // border-bottom: 0;
            border-radius: 0.2rem 0.2rem 0 0;

            div:nth-child(1) {
                background: url("~@/assets/images/illustrate.png") center no-repeat;
                width: 80%;
                height: 1.3rem;
                background-size: contain;
                position: relative;
                margin: 0 auto;
                font-size: 22px;
                margin-top: -0.46rem;
                line-height: 1.3rem;
                color: #ff2900;
            };
            div {
                p {
                    line-height: 25px;
                    margin-bottom: 10px
                }
            }
        }
        .prizeimg {
            /*height: 36px;*/
        }
        .prizeimg img {
            width: 80px;
            height: 80px!important;
        }

        .return-back1 {
            z-index: 999;
            width: auto;
            position: fixed;
            right: 0;
            top: 50px;
            padding: 10px 0;
            .back-right {
                width: auto;
                padding: 0 10px;
                height: 30px;
                border: 1px solid #fff;
                background: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #0b9444;
                font-weight:bold;
                border-radius: 14px 0 0 14px;
                font-size: 15px;
            }
        }
    }
    .cell-title {
        width: 70px;          /* 固定宽度 */
        flex-shrink: 0;        /* 防止被压缩 */
        overflow: hidden;      /* 超出隐藏 */
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
    }

    .cell-value {
        flex: 1;               /* 占满剩余空间 */
        text-align: right;     /* 右对齐 */
        font-size: 12px;
    }
</style>